import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../../store'
import { getCookie } from "@/utils/cookieinfo.js";

Vue.use(VueI18n)

let locale = getCookie('lang');

const i18n = new VueI18n({
  locale: locale==1?'zh':'en',
  messages: {
     'zh': require('./zh'),
     'en': require('./en')
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/common/lang/index.js